import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { YearlyBudgetComponent } from './yearly-budget.component';

const routes: Routes = [
  {
    path: '',
    component: YearlyBudgetComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class YearlyBudgetRoutingModule { }
